import SignupContainer from './containers/Signup.container'

export default {
  component : SignupContainer
}



// WEBPACK FOOTER //
// ./src/routes/Signup/index.js